import { resolveActivationOdds } from '../ActivationBadge/resolveActivationOdds';
import type { ApprovalOddsResponse } from '../constants';

export type ApprovalOddsData = {
  cards_on_page: number;
  cards_with_odds: number;
  odds_by_card: Record<string, string | null>;
};

export function buildApprovalOddsCoverage(
  marketplaceIds: string[],
  approvalOdds: ApprovalOddsResponse,
): ApprovalOddsData {
  const uniqueIds = [...new Set(marketplaceIds)];
  const oddsByCard = Object.fromEntries(
    uniqueIds.map(id => [id, resolveActivationOdds(approvalOdds, id)?.approvalLikelihood ?? null]),
  );

  return {
    cards_on_page: uniqueIds.length,
    cards_with_odds: Object.values(oddsByCard).filter(odds => odds !== null).length,
    odds_by_card: oddsByCard,
  };
}
